import { useState } from "react";

export default function useLocalStorage(key, initialValue) {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      
      var tempItem = item ? JSON.parse(item) : [];


      if (tempItem) {
        if (new Date(tempItem.data) > new Date()) {
          return tempItem.obbj;
        } else {     
          return null;
        }
      }

     
    } catch (error) {
      console.log(error);
      return initialValue;
    }
  });

  const setValue = (value, time) => {
    try {
      var obbjTemp = {};
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;

      var today = new Date();
      var addTime = time ? time : 60
      
      today.setMinutes(today.getMinutes() + addTime);

      obbjTemp["obbj"] = valueToStore;

      if(time){

        
      }
      obbjTemp["data"] = today;
      setStoredValue(obbjTemp.obbj);
      window.localStorage.setItem(key, JSON.stringify(obbjTemp));
    } catch (error) {
      console.log(error);
    }
  };

  const removeValue = () => {
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      console.log(error);
    }
  };
  return [storedValue, setValue, removeValue];
}
